const chunkMapping = {
	"86": [
		70086
	],
	"203": [
		50203
	],
	"339": [
		339
	],
	"483": [
		50483
	],
	"1129": [
		11129
	],
	"1475": [
		31475
	],
	"1855": [
		41855
	],
	"2070": [
		82070
	],
	"2475": [
		82475
	],
	"3006": [
		63006
	],
	"3041": [
		73041
	],
	"3723": [
		33723
	],
	"3855": [
		93855
	],
	"3856": [
		11475
	],
	"3870": [
		93870
	],
	"4403": [
		4403
	],
	"4707": [
		64707
	],
	"4708": [
		94708
	],
	"4792": [
		64792
	],
	"4859": [
		34859
	],
	"5842": [
		15842
	],
	"6006": [
		86006
	],
	"6155": [
		6155
	],
	"6172": [
		86172
	],
	"6351": [
		86351
	],
	"6405": [
		26405
	],
	"6906": [
		96906
	],
	"6969": [
		66969
	],
	"7408": [
		97408
	],
	"7572": [
		27572
	],
	"7605": [
		7605
	],
	"7733": [
		57733
	],
	"7958": [
		67958
	],
	"9083": [
		9083
	],
	"9890": [
		9890
	],
	"9947": [
		19947
	]
};
const idToExternalAndNameMapping = {
	"339": [
		"default",
		"./RollupExceptions",
		8621
	],
	"4403": [
		"default",
		"./ClientDataStoreConfig",
		97107
	],
	"6155": [
		"default",
		"./App",
		65483
	],
	"7605": [
		"default",
		"./DataAuditCompliance",
		97107
	],
	"9083": [
		"default",
		"./App",
		38415
	],
	"9890": [
		"default",
		"./App",
		90401
	],
	"11129": [
		"default",
		"./AttributionRulesPage",
		87839
	],
	"11475": [
		"default",
		"./EnginesModule",
		58883
	],
	"15842": [
		"default",
		"./FormularyConfig",
		8621
	],
	"19947": [
		"default",
		"./DrugChangeReview",
		53969
	],
	"26405": [
		"default",
		"./ClientHierarchy",
		53969
	],
	"27572": [
		"default",
		"./ClientDataOperations",
		97107
	],
	"31475": [
		"default",
		"./StepLibraryTab",
		58883
	],
	"33723": [
		"default",
		"./WhatIfScenarios",
		53969
	],
	"34859": [
		"default",
		"./App",
		85615
	],
	"41855": [
		"default",
		"./CatalogManagement",
		53969
	],
	"50203": [
		"default",
		"./SavingsDashboard",
		87839
	],
	"50483": [
		"default",
		"./SavingsAnalysisDashboard",
		85615
	],
	"57733": [
		"default",
		"./AltPairs",
		53969
	],
	"63006": [
		"default",
		"./Audit",
		53969
	],
	"64707": [
		"default",
		"./DataModule",
		97107
	],
	"64792": [
		"default",
		"./OaRuns",
		85615
	],
	"66969": [
		"default",
		"./AnalyticsApp",
		87839
	],
	"67958": [
		"default",
		"./RulesManagementTab",
		58883
	],
	"70086": [
		"default",
		"./DdidRollupDashboard",
		8621
	],
	"73041": [
		"default",
		"./ChannelDeliveryPage",
		8621
	],
	"82070": [
		"default",
		"./ClientConfig",
		53969
	],
	"82475": [
		"default",
		"./WorkflowsModule",
		58883
	],
	"86006": [
		"default",
		"./MessagesPage",
		8621
	],
	"86172": [
		"default",
		"./PTReviewCycles",
		53969
	],
	"86351": [
		"default",
		"./RankingConfig",
		53969
	],
	"93855": [
		"default",
		"./AnalyticsRulesPage",
		8621
	],
	"93870": [
		"default",
		"./Research",
		53969
	],
	"94708": [
		"default",
		"./App",
		18377
	],
	"96906": [
		"default",
		"./ClaimsConfig",
		8621
	],
	"97408": [
		"default",
		"./App",
		8621
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}